import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["mainForm"];

  connect() {
    this.addressRecognitionToggle = this.element.querySelector("#address-recognition-toggle");
    this.addressRecognitionForm = this.element.querySelector("#address-recognition-form");
    this.addressRecognitionCheckbox = this.element.querySelector("input[type='checkbox']");
    this.addressRecognitionSubmit = this.element.querySelector("#address-recognition-submit");

    // Make the text clickable
    if (this.addressRecognitionToggle) {
      this.addressRecognitionToggle.style.cursor = "pointer";
    }

    // Initially hide the submit button
    if (this.addressRecognitionSubmit) {
      this.addressRecognitionSubmit.hidden = true;
    }

    // Check if the checkbox is already checked on page load
    if (this.addressRecognitionCheckbox && this.addressRecognitionCheckbox.checked) {
      this.handleInitialState();
    }
  }

  handleInitialState() {
    const mainForm = document.getElementById("main-applicant-form");
    if (mainForm) {
      mainForm.hidden = true;
    }

    if (this.addressRecognitionForm) {
      this.addressRecognitionForm.hidden = false;
    }

    if (this.addressRecognitionSubmit) {
      this.addressRecognitionSubmit.hidden = false;
    }
  }

  toggleCheckbox(event) {
    event.preventDefault();
    if (this.addressRecognitionForm) {
      this.addressRecognitionForm.hidden = !this.addressRecognitionForm.hidden;
    }
  }

  toggleForms(event) {
    const doesNotRecognizeAddress = event.target.checked;
    const mainForm = document.getElementById("main-applicant-form");

    if (mainForm) {
      mainForm.hidden = doesNotRecognizeAddress;
    }

    // Toggle submit button visibility
    if (this.addressRecognitionSubmit) {
      this.addressRecognitionSubmit.hidden = !doesNotRecognizeAddress;
    }
  }
}
